import { Component } from '@theme/component';

/**
 * Switches between the views of an image views block (for example "Full frame" and "Close-up").
 *
 * @typedef {object} Refs
 * @property {HTMLImageElement[]} [views] - The images, in the same order as the options.
 * @property {HTMLButtonElement[]} [options] - The switch buttons.
 * @property {HTMLElement} [caption] - Caption with `data-caption-first` / `data-caption-second` texts.
 *
 * @extends {Component<Refs>}
 */
class ImageViewsComponent extends Component {
  /**
   * Shows the view at `index` and marks its button as pressed.
   * @param {number} index - The view to show.
   */
  select(index) {
    const { views = [], options = [], caption } = this.refs;
    if (!views[index]) return;

    if (caption) {
      const text = (index === 0 ? caption.dataset.captionFirst : caption.dataset.captionSecond) ?? '';
      if (caption.textContent !== text) {
        caption.textContent = text;
        caption.style.setProperty('--image-views-caption-length', String(text.length));
      }
    }

    for (const [i, view] of views.entries()) {
      view.hidden = i !== index;
    }

    for (const [i, option] of options.entries()) {
      option.setAttribute('aria-pressed', String(i === index));
    }
  }
}

if (!customElements.get('image-views-component')) {
  customElements.define('image-views-component', ImageViewsComponent);
}
